import { Link } from "react-router-dom";
import stl from "./MakeModelYearTag.module.css";

const MakeModelYearTag = ({ title, url }) => {
  return (
    <Link to={url} className={stl.tag} >
      {title}
    </Link>
  );
};

export default MakeModelYearTag;
